module.exports = __webpack_public_path__ + "img/appgallery_ar.a304df2d.png";